<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          <h4>Αναφορά Υπεργολάβων</h4>
        </CCardHeader>
        <CCardBody>
          <CModal
            class="modalAlert"
            :show.sync="alertIsShown"
            :centered="true"
            size="lg"
          >
            <CAlert
              closeButton
              :show.sync="alertIsShown"
              color="primary"
              fade
            >
              {{ message }}
            </CAlert>
          </CModal>
          <CButton
            color="primary"
            class="mb-2"
            @click="xlsCode"
            target="_blank"
          >
            Download (.xls)
          </CButton>
          <CDataTable
            :items="filteredItems"
            :fields="fields"
            :items-per-page="10"
            pagination
            column-filter
            table-filter
            hover
            striped
            :loading="loading"
            sorter
            @row-clicked="(item) => showClient(item.client_id)"
            clickable-rows
          >
          <template #services-filter>
            <div class="selectFilter">
              <CSelect
                :options="servicesOptions"
                :value.sync="selectedIsoOption"
              />
            </div>
          </template>
          <template #name="{item}">
            <td>
              {{ item.name }}
            </td>
          </template>
          <template #services="{item}">
            <td>
              {{ item.services }}
            </td>
          </template>
          <template #client="{item}">
            <td>
              {{ item.client }}
            </td>
          </template>
          <template #actions="{item}">
            <td class="button-cell">
              <CButton
                color="primary"
                class="btn-icon"
                @click.stop="editClient( item.client_id )"
                v-c-tooltip="'Επεξεργασία'"
              >
                <CIcon name="cilPencil" />
              </CButton>
            </td>
          </template>
        </CDataTable>
        </CCardBody>
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
import js2excel from 'js2excel';

const fields = [
  {
    key: 'name', 
    label: 'Ονοματεπώνυμο', 
    sorter: true, 
    filter: true
  },
  {
    key: 'services', 
    label: 'Πρότυπο', 
    sorter: true, 
    filter: true
  },
  {
    key: 'price_service', 
    label: 'Ποσό', 
    sorter: true, 
    filter: true
  },
  {
    key: 'client',
    label: 'Πελάτης',
    sorter: true,
    filter: true
  },
  {
    key: 'actions',
    label: '',
    sorter: false,
    filter: false
  }
]

export default {
  name: 'SubcontractorsReports',
  data: () => {
    return {
      items: [],
      fields,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      disabledFilter: true,
      selectedIsoOption: 'Καμία επιλογή',
      servicesOptions: ['Καμία επιλογή'],
      you: null,
      message: '',
      showMessage: false,
      dismissSecs: 7,
      alertIsShown: false,
      dismissCountDown: 0,
      loading: true,
      showDismissibleAlert: false
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  computed: {
    filteredItems() {
      if (this.selectedIsoOption == "Καμία επιλογή") {
        return this.items;
      }
      return this.items.filter(item => {
        const services = item.services;

        return services == this.selectedIsoOption;
      })
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    xlsCode () {
      this.tempArr = this.filteredItems.map((item) => {
        return {
          Ονοματεπώνυμο: item.name,
          Πρότυπο: item.services,
          Ποσό: item.price_service+'€',
          Πελάτης: item.client
        }
      });

      try {
        js2excel.json2excel({
            data: this.tempArr,
            name: 'subcontractors-data',
            formateDate: 'dd/mm/yyyy'
        });
      } catch (e) {
          console.error('export error: ', e);
      }
    },
    clientLink (id) {
      return `clients/${id.toString()}`
    },
    editLink (id) {
      return `clients/${id.toString()}/edit`
    },
    showClient ( id ) {
      const clientLink = this.clientLink( id );
      this.$router.push({path: clientLink});
    },
    editClient ( id ) {
      const editLink = this.editLink( id );
      this.$router.push({path: editLink});
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
    getSubcontractorsReports (){
      let self = this;

      axios.get('/api/subcontractors/get_clients_services_subcontractors?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        self.items = response.data.cases_inspectors.map((item) => {
            item.name = item.subcontractors ? item.subcontractors.name : '-';
            item.services = item.services.name;
            item.client = item.clients.company;
          return item;
        });
        self.you = response.data.you;
        self.loading = false;
      }).catch(function (error) {
        console.log(error);
        self.loading = false;
        self.$router.push({ path: '/login' });
      });
    },
  },
  mounted: function(){
    this.getSubcontractorsReports();

    let self = this;

    axios.get('/api/services?token=' + localStorage.getItem("api_token"))
    .then(function (response) {
      self.services = response.data.services.map((item) => {
        return item;
      });

      self.servicesOptions = ['Καμία επιλογή', ...new Set(self.services.map(item => item.name))];
      self.selectedIsoOption = self.servicesOptions[0];

    }).catch(function (error) {
      console.log(error);
      self.loading = false;
      self.$router.push({ path: '/login' });
    });
  }
}
</script>